import React, { useState } from 'react';
import { ConfigProvider, DatePicker } from 'antd';
import { getCurrentLanguage } from '@/utils/locale';
import enUS from 'antd/es/locale/en_US';
import thTH from 'antd/es/locale/th_TH';

import './index.scss';

const dateFormat = 'DD-MM-YYYY';

function DatePickerComponent({ ...props }) {
  const [locale] = useState(() => {
    const currentLanguage = getCurrentLanguage();
    switch (currentLanguage) {
      case 'en':
        return enUS;
      case 'th':
        return thTH;
      default:
        return enUS;
    }
  });

  return (
    <div className="date-picker-container">
      <ConfigProvider locale={locale}>
        <DatePicker format={dateFormat} {...props} />
      </ConfigProvider>
    </div>
  );
}

DatePickerComponent.propTypes = {};

export default DatePickerComponent;
